// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqConfirmationHeaderStyles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationHeader";
import Print from "@steiner/XDL/Icons/Print";
import { css } from "styled-components";

rfqConfirmationHeaderStyles.headerGridContainer = {
    gap: 10,
    css: css`
        margin-bottom: 16px;
    `,
};

rfqConfirmationHeaderStyles.viewQuotesButton = {
    variant: "secondary",
};

rfqConfirmationHeaderStyles.continueButton = {};

rfqConfirmationHeaderStyles.printButton = {
    variant: "link" as any,
    icon: {
        src: Print,
        position: "left",
    },
};

rfqConfirmationHeaderStyles.buttonsHiddenContainer = {
    below: "lg",
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px 12px;
    `,
};
